import { render, staticRenderFns } from "./SellForm.vue?vue&type=template&id=01a3b8fc"
import script from "./SellForm.vue?vue&type=script&lang=js"
export * from "./SellForm.vue?vue&type=script&lang=js"
import style0 from "./SellForm.vue?vue&type=style&index=0&id=01a3b8fc&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports